export const getPageId = (jsonFile, urlParams) => {
  const defaultPage = { url: urlParams, markdown: "page-not-found.md" };
  const filteredList = jsonFile.filter(
    (file) => file.fileName == urlParams && file.isVisible === true
  );
  return filteredList.length > 0 ? filteredList[0] : defaultPage;
};
